import {
  DateIcon,
  DateIconSvg,
  EmailIcon,
  PhoneIcon,
  RightArrowWithoutBar,
} from "../../components/styled/AllImages";
import {
  ButtonStyled,
  InfoWithIcon,
  SpanStyled,
  UserInfo,
} from "../../components/styled/Elements";
import {
  formatAmountForDisplay,
  formatDate,
  getFormattedDate,
} from "../../utils";

export const productsCategoriesColumns = [
  { label: "no", name: "id" },
  {
    label: "name_en",
    name: "name_en",
  },
  { label: "name_ar", name: "name_ar" },
  {
    label: "no_of_products",
    name: "no_of_products",
  },
  { label: "actions", name: "actions" },
];

export const productsListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "type",
    name: "product_type",
    render: (type, row, t) =>
      parseInt(type) === 1 ? (
        <SpanStyled
          radius="10px"
          padding="5px 15px"
          color="var(--green)"
          bg="var(--lightGreen)"
        >
          {t("product")}
        </SpanStyled>
      ) : (
        <SpanStyled
          radius="10px"
          padding="5px 17.5px"
          color="var(--themeColor)"
          bg="var(--lightBlue)"
        >
          {t("service")}
        </SpanStyled>
      ),
  },
  {
    label: "name",
    name: "name",
    render: (user, row, t, lang) => (
      <UserInfo
        name={lang === "en" ? row?.name_en : row?.name_ar}
        avatar={row?.images}
      />
    ),
  },
  {
    label: "unit_of_measurement",
    name: "unit_of_measurement",
  },
  {
    label: "price",
    name: "price",
    render: (item, row, t, lang, user) => (
      <>
        {item} {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "actions",
    name: "actions",
  },
];

export const clientsListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "type",
    name: "client_type",
    render: (type, row, t) =>
      parseInt(row?.client_type) === 1 ? (
        <SpanStyled
          radius="10px"
          padding="5px 24px"
          color="var(--green)"
          bg="var(--lightGreen)"
        >
          {t("individual")}
        </SpanStyled>
      ) : (
        <SpanStyled
          radius="10px"
          padding="5px 12px"
          color="var(--themeColor)"
          bg="var(--lightBlue)"
        >
          {t("organization")}
        </SpanStyled>
      ),
  },
  {
    label: "name_en",
    name: "name_en",
  },
  {
    label: "name_ar",
    name: "name_ar",
  },
  {
    label: "email",
    name: "email",
    render: (user, row, t, lang) =>
      row?.email ? <InfoWithIcon text={row?.email} icon={EmailIcon} /> : "N/A",
  },
  {
    label: "actions",
    name: "actions",
  },
];

export const UsersListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "name",
    name: "name",
    render: (user, row, t, lang) => (
      <UserInfo name={row?.name} avatar={row?.profile} />
    ),
  },
  {
    label: "job_title",
    name: "job_title",
  },
  {
    label: "email",
    name: "email",
    render: (user, row, t, lang) => (
      <InfoWithIcon text={user} icon={EmailIcon} />
    ),
  },
  {
    label: "phone",
    name: "phone",
    render: (user, row, t, lang) => (
      <InfoWithIcon text={user} icon={PhoneIcon} />
    ),
  },
  {
    label: "actions",
    name: "actions",
  },
];

export const QuotationsListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "title",
    name: "name",
  },
  {
    label: "quotation_no",
    name: "quotation_no",
  },
  {
    label: "client",
    name: "client_name",
  },
  {
    label: "date",
    name: "date",
    render: (user, row, t, lang) => (
      <InfoWithIcon text={user} icon={DateIcon} />
    ),
  },
  {
    label: "amount",
    name: "amount",
  },
  {
    label: "actions",
    name: "actions",
  },
];

export const InvoicesListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "title",
    name: "name",
  },
  {
    label: "invoice_no",
    name: "invoice_no",
  },
  {
    label: "client",
    name: "client",
    render: (user, row, t, lang) =>
      lang === "en" ? row?.client_name_en : row?.client_name_ar,
  },
  {
    label: "date",
    name: "date",
    render: (user, row, t, lang) => (
      <InfoWithIcon text={user} icon={DateIcon} />
    ),
  },
  {
    label: "amount",
    name: "total_amount",
  },
  {
    label: "actions",
    name: "actions",
  },
];

export const CreateQuotationListColumns = [
  { name: "no", label: "no" },
  { name: "category", label: "category" },
  { name: "product", label: "product" },
  { name: "quantity", label: "quantity" },
  { name: "unit_price", label: "unit_price" },
  { name: "unit", label: "unit" },
  { name: "total", label: "total" },
  { name: "discount", label: "discount" },
  { name: "net_total", label: "net" },
  { name: "vat", label: "vat" },
  { name: "subtotal", label: "subtotal" },
  { name: "actions", label: "action" },
];
export const ViewQuotationListColumns = [
  { name: "no", label: "no" },
  { name: "category", label: "category" },
  { name: "product", label: "product" },
  { name: "quantity", label: "quantity" },
  { name: "unit_price", label: "unit_price" },
  { name: "unit", label: "unit" },
  { name: "total", label: "total" },
  { name: "discount", label: "discount" },
  { name: "net_total", label: "net" },
  { name: "vat", label: "vat" },
  { name: "subtotal", label: "subtotal" },
];

export const userDtlPermissionColumns = [
  {
    title: "features",
    name: "module_name",
  },
  {
    title: "all",
    name: "all",
  },
  // {
  //   title: "Open",
  //   name: "open",
  // },
  {
    title: "Create",
    name: "create",
  },
  {
    title: "edit",
    name: "edit",
  },
  {
    title: "view",
    name: "view",
  },
  {
    title: "delete",
    name: "delete",
  },
];

export const invoiceListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "invoice_no",
    name: "invoice_no",
  },
  {
    label: "date",
    name: "date",
    render: (date) => (
      <span>
        <i className="bi bi-calendar3 me-2" />
        {formatDate(date)}
      </span>
    ),
  },
  {
    label: "client",
    name: "client",
  },
  {
    label: "quantity",
    name: "quantity",
  },
  {
    label: "unit_price",
    name: "unit_price",
    render: (item, row, t, lang, user) => (
      <>
        {item} {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "total_price",
    name: "total_price",
    render: (item, row, t, lang, user) => (
      <>
        {item} {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "view_invoice",
    name: "view_invoice",
    render: (item, row, t, lang) => (
      <ButtonStyled
        icon={RightArrowWithoutBar}
        label={t("view_invoice")}
        color="var(--text)"
        border="var(--border)"
        bg="var(--white)"
        onClick={() => {
          window.open(`/sales-invoices/${row?.id}/view-invoice`, "_blank");
        }}
      />
    ),
  },
];

export const quotationListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "quotation_no",
    name: "quotation_no",
  },
  {
    label: "date",
    name: "date",
    render: (date) => (
      <span>
        <i className="bi bi-calendar3 me-2" />
        {formatDate(date)}
      </span>
    ),
  },
  {
    label: "client",
    name: "client",
  },
  {
    label: "quantity",
    name: "quantity",
  },
  {
    label: "unit_price",
    name: "unit_price",
    render: (item, row, t, lang, user) => (
      <>
        {item} {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "total_price",
    name: "total_price",
    render: (item, row, t, lang, user) => (
      <>
        {item} {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "view_quotation",
    name: "view_quotation",
    render: (item, row, t, lang) => (
      <ButtonStyled
        icon={RightArrowWithoutBar}
        label={t("view_quotation")}
        color="var(--text)"
        border="var(--border)"
        bg="var(--white)"
        onClick={() => {
          window.open(`/quotations/${row?.id}/view-quotation`, "_blank");
        }}
      />
    ),
  },
];
export const quotationDetailsListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "title",
    name: "name",
  },
  {
    label: "quotation_no",
    name: "quotation_no",
  },
  {
    label: "client",
    name: "client",
    render: (client, row, t, lang, user) => (
      <>{lang === "en" ? row?.client_name_en : row?.client_name_ar}</>
    ),
  },
  {
    label: "date",
    name: "date",
    render: (date) => (
      <span>
        <DateIconSvg className="bi bi-calendar3 me-2" />
        {getFormattedDate(date)}
      </span>
    ),
  },
  {
    label: "amount",
    name: "total_amount",
    render: (amount, row, t, lang, user) => (
      <>
        {formatAmountForDisplay(amount)}{" "}
        {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "action",
    name: "actions",
  },
];
export const invoiceDetailsListColumns = [
  {
    label: "no",
    name: "id",
  },
  {
    label: "title",
    name: "name",
  },
  {
    label: "invoice_no",
    name: "invoice_no",
  },
  {
    label: "client",
    name: "client",
    render: (client, row, t, lang, user) => (
      <>{lang === "en" ? row?.client_name_en : row?.client_name_ar}</>
    ),
  },
  {
    label: "date",
    name: "date",
    render: (date) => (
      <span>
        <DateIconSvg className="bi bi-calendar3 me-2" />
        {getFormattedDate(date)}
      </span>
    ),
  },
  {
    label: "amount",
    name: "total_amount",
    render: (amount, row, t, lang, user) => (
      <>
        {formatAmountForDisplay(amount)}{" "}
        {user?.organization?.currency?.stringCode || t("sar")}
      </>
    ),
  },
  {
    label: "action",
    name: "actions",
  },
];
